<app-navbar-style-two></app-navbar-style-two>

<!-- <app-posnavbar></app-posnavbar> -->
<!-- <div class="banner-area-two client-slider owl-carousel owl-theme">
    <div class="client-item">
        <img src="https://medeilpos.blob.core.windows.net/websiteimage/bestpharmacysoftware.png" alt="best pharmacy software">
        <div class="overlay-buttons row">
            <div class="col-lg-6">
                <button type="button" class="default-btn1">14 Days Free Trial</button>
            </div>
            <div class="col-lg-6">
                <button type="button" class="default-btn1" (click)="appointment('Pharmacy Vertical')">Demo Request</button>
            </div>
        </div>
    </div>
</div> -->
<div class="slider-area owl-carousel owl-theme">
  <div class="slider-item item-bg-pharmacy">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="container">
                  <div class="slider-content">
                      <h1 i18n>Modern Pharmacy POS: Streamlined Growth Solutions</h1>
                      <!-- <h3 i18n>Effortlessly Manage Inventory, Billing, and Prescriptions with Our Advanced Pharmacy Software</h3> -->


                          <button i18n type="button" class="default-btn" (click)="appointment('Pharmacy Vertical')">Request a Free Demo</button>

                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<br>
<div class="container-md p-5 box-container">
    <p i18n style="color:white">"In today's rapidly evolving healthcare landscape, pharmacies face unprecedented challenges – from managing complex inventories and ensuring regulatory compliance to delivering exceptional patient care and maximizing profitability. Medeil's Pharmacy Management Software is not just a tool; it's a strategic partner, empowering modern pharmacies to thrive in this dynamic environment. Our comprehensive solution goes beyond traditional pharmacy management, offering intelligent automation, data-driven insights, and seamless integration to revolutionize your workflows and unlock new levels of success."</p>
</div>
<br>



<ngx-smart-modal #enquirypos identifier="enquirypos" [closable]="false">


  <div class="custom-modal">
     <button class="close-btn" (click)="closeModal()">X</button>
     <div class="modal-header">
         <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
     </div>
       <div class="modal-body">
         <form [formGroup]="enquiryForm">
           <div class="form-group">
             <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
             <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
            </div>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
             <!-- <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="countryname1"> -->
             <select class="form-control"  formControlName="countryname1" style="font-size: 12px;" (change)="countrychange()">
              <!-- (change)="countrychange()" -->
              <option i18n select disabled value="0" >---Select Country---</option>
              <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>

            </select>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
             <div class="row">
               <div class="col-lg-3">
                 <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
               </div>
               <div class="col-lg-9">
                 <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                 autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
               </div>
             </div>

           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
           </div>
           <!-- <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Enter captcha</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name">
           </div> -->
           <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
           <div class="input-group">
              <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
               (change)="checkCaptcha()"/>
              <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
              [(ngModel)]="captcha"/>
              <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
            </div>
            <div *ngIf="ecaptcha">
              <p style="color: red">{{ errorcaptcha }}</p>
            </div>
           <div class="form-group">

                 <label i18n class="container1 mt-3">I Accept Terms & Conditions & MEDEIL Privacy Policy – Your Data Security & Rights
                     <input type="checkbox" checked="checked" formControlName="checkbox">
                     <span class="checkmark"></span>
                 </label>
           </div>
           <div class="btn-group mt-3" *ngIf="!showElement">
             <button i18n type="button" class="enquiry-btn" (click)="submitenquery()" >Submit</button>

           </div>


         </form>
       </div>
 </div>
</ngx-smart-modal>
<ngx-smart-modal #appointmentform identifier="appointmentform" [closable]="false">


  <div class="custom-modal"  >
     <button class="close-btn" (click)="closeModal()">X</button>
      <div class="modal-header-appointment">
          <h4 i18n class="modal-title" id="exampleModalLabel">Demo Request</h4>
      </div>
        <div class="modal-body">

           <div class="row">
              <div class="col-lg-12">
                 <mat-form-field >

                    <input matInput [matDatepicker]="picker" placeholder="Choose a date" (dateChange)="slectdate($event)" >
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                 </mat-form-field>

              </div>
              <div  align="center" *ngIf="showElement">
                 <img height="200px" width="200px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
               </div>
              <div class="col-lg-12" *ngIf="appointment_time">

                  <div class="button-container">
                    <button class="flex-button" *ngFor="let time of timeSlots" (click)="selectTime(time)" [ngClass]="{ 'clicked': selectedTime === time }">{{ time }}</button>
                </div>
                <div  align="center" *ngIf="showElementsave">
                  <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
                </div>
                  <div class="shedule-submit">
                    <button i18n class="shedulebtn" (click)="savelead()">Submit</button>
                  </div>
              </div>
           </div>

        </div>
  </div>
</ngx-smart-modal>
<div class="newslider" >

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/anu-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/apollo-hospitals.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bellamed-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bk-heart-hospital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/booncholai-super-market.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/emedsure.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/express-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/falcon-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/global-bridge-pharmaceutical.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/hawi-family-hostpital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/henry-jackson-foundation.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/imcri.webp" alt="image" height="200" width="300" priority>
  </div>

</div>
<!-- <div class="section-title container gradient-text mb-2" >

    <h2>Features</h2>
</div> -->
<!-- ---------------------------- -->


<div id="services" class="services section">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-heading  wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
            <div i18n class="gradient-text"><h2>Pharmacy Management Software &amp; Streamline Your Pharmacy Operations </h2>for you</div>
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
             <p i18n>Running a pharmacy is no easy task. From managing inventory and prescriptions to ensuring compliance with regulations, the challenges can quickly pile up. That’s where Medeil’s Pharmacy Management Software comes in – a comprehensive solution designed to simplify your operations, reduce errors, and help your pharmacy thrive.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <div class="service-item first-service">
            <div class="icon"></div>
            <h4 i18n>Save Time and Reduce Errors</h4>
            <p i18n>Automate repetitive tasks like billing and inventory tracking, so you can focus on serving your customers.
            </p>
            <div class="text-button">
              <a i18n >Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item second-service">
            <div class="icon"></div>
            <h4 i18n>Improve Efficiency</h4>
            <p i18n>Streamline your operations and reduce bottlenecks, ensuring faster service and happier customers.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item third-service">
            <div class="icon"></div>
            <h4 i18n>Stay Compliant</h4>
            <p i18n>With built-in GST compliance and accurate record-keeping, you can avoid penalties and audits.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item fourth-service">
            <div class="icon"></div>
            <h4 i18n>Boost Profitability</h4>
            <p i18n>Optimize inventory, reduce wastage, and make smarter business decisions with actionable insights.</p>
            <div class="text-button">
              <a i18n >Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- ---------------------------- -->




<section class="benefits-section">
  <div class="container">
  <div class="benefit-cards">
      <div class="benefit-card1">
            <div class="icon"><i class="fas fa-hospital"></i></div>
            <h3 i18n>Intelligent Inventory Optimization</h3>
            <p i18n>"Say goodbye to stockouts and overstocking. Our advanced inventory management system uses predictive analytics to forecast demand, optimize stock levels, and minimize waste, ensuring you always have the right medications on hand."</p>
      </div>


          <div class="benefit-card1">
              <div class="icon"><i class="fas fa-hospital"></i></div>
              <h3 i18n>Automated Prescription Processing</h3>
              <p i18n>"Reduce errors and streamline prescription workflows with our automated processing system. From electronic prescription capture to automated dispensing, our solution minimizes manual tasks and frees up your staff to focus on patient care."</p>
          </div>

          <div class="benefit-card1">
              <div class="icon"><i class="fas fa-hospital"></i></div>
              <h3 i18n>Proactive Compliance Management</h3>
              <p i18n>"Stay ahead of ever-changing regulations with our proactive compliance management tools. Our system automatically tracks regulatory updates, generates compliance reports, and ensures your pharmacy operates within legal guidelines."</p>
          </div>

          <div class="benefit-card1">
              <div class="icon"><i class="fas fa-hospital"></i></div>
              <h3 i18n>Enhanced Patient Engagement</h3>
              <p i18n>"Elevate the patient experience with personalized communication tools and convenient online portals. Our solution enables you to engage patients with targeted messaging, refill reminders, and secure access to their prescription information."</p>
           </div>
            <div class="benefit-card1">
              <div class="icon"><i class="fas fa-hospital"></i></div>
              <h3 i18n>Data-Driven Performance Insights</h3>
              <p i18n>Unlock the power of your pharmacy data with our comprehensive analytics dashboard. Track key performance indicators, identify trends, and make informed decisions to optimize your operations and maximize profitability.</p>
           </div>
      </div>
    </div>
</section>



<!-- about  -->
<div id="about" class="about-us section">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 align-self-center">
        <div class="section-heading">
          <h4 i18n>About we do?</h4>
          <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
          <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
          <p i18n>At Vanuston, we specialize in creating state-of-the-art pharmacy software solutions that improve patient care, expedite processes, and boost productivity in pharmacies of all kinds.</p>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="box-item" routerLink="/medeil-pharmacy-software">
              <h5 i18n><a >Standalone Version</a></h5>
              <!-- <p class="ptag">Lorem Ipsum Text</p> -->
            </div>
          </div>
          <div class="col-lg-6">
            <div class="box-item" routerLink="/medeil-cloud-pos">
              <h5 i18n><a >SaaS Version</a></h5>
              <!-- <p class="ptag">Lorem Ipsum Text</p> -->
            </div>
          </div>
          <div class="col-lg-6">
            <div class="box-item" routerLink="/medeil-cloud-hq">
              <h5 i18n><a >Chain Store Version</a></h5>
              <!-- <p class="ptag">Lorem Ipsum Text</p> -->
            </div>
          </div>
          <div class="col-lg-6">
            <div class="box-item" routerLink="/allotmed-medical-supply">
              <h5 i18n><a >Distribution Version</a></h5>
              <!-- <p class="ptag">Lorem Ipsum Text</p> -->
            </div>
          </div>
          <div class="col-lg-12 text-center">
            <div class="box-item" routerLink="/hosbay-healthcare">
              <h5 i18n><a >Hospital Inventory  Version</a></h5>
              <!-- <p class="ptag">Lorem Ipsum Text</p> -->
            </div>
          </div>
          <div class="col-lg-12">
            <p i18n>At Vanuston, we're more than just a software supplier—we're a dependable ally committed to helping pharmacies achieve unprecedented success and significantly improve the health and well-being of their clientele.</p>
            <div>
              <!-- <button class="gradient-button"> Start Trial</button> -->
             </div>
            <!-- <span>*No Credit Card Required</span> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="right-image">
          <img src="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloudpos.gif" alt="medical pos billing- medeilcloud pos" loading="lazy">
        </div>
      </div>
    </div>
  </div>
</div>

<section class="benefits-section">
  <div class="container">
      <h3 i18n class="section-title">Who Can Benefit from Medeil’s Pharmacy Software?</h3>
      <p i18n class="section-description">
          Our software is designed for various pharmacy businesses, ensuring efficiency and seamless management.
      </p>

      <div class="benefit-cards">
          <div class="benefit-card">
              <div class="icon"><i class="fas fa-store"></i></div>
              <h3 i18n>Independent Pharmacies</h3>
              <p i18n>Transform your independent pharmacy into a modern, efficient operation with our comprehensive management tools</p>
          </div>

          <div class="benefit-card">
              <div class="icon"><i class="fas fa-building"></i></div>
              <h3 i18n>Chain Pharmacies</h3>
              <p i18n>Standardize processes, improve communication, and optimize performance across your entire pharmacy chain</p>
          </div>

          <div class="benefit-card">
              <div class="icon"><i class="fas fa-hospital"></i></div>
              <h3 i18n>Specialty Pharmacies</h3>
              <p i18n>Manage complex specialty medications, track patient adherence, and ensure compliance with stringent regulatory requirements</p>
          </div>

          <div class="benefit-card">
              <div class="icon"><i class="fas fa-hospital"></i></div>
              <h3 i18n>Hospital Pharmacies</h3>
              <p i18n>Streamline medication management, reduce errors, and improve patient safety within your hospital pharmacy.</p>
          </div>
      </div>
  </div>
</section>



<br>
<section class="box-container">
    <div class="container">
        <div class="cta-section">
            <h3 i18n>Why Choose Medeil for pharmacy?</h3>
            <p i18n>Medeil is more than just a software provider; we're a dedicated partner committed to the success of your pharmacy. Our team of industry experts understands the unique challenges you face, and we've designed our Pharmacy Management Software to address those challenges head-on. With Medeil, you're not just getting a product; you're gaining a strategic advantage that will propel your pharmacy to new heights.</p>
            <a i18n (click)="appointment('Medeil Cloud POS-Free Demo')" class="cta-button">🚀 Request a Free Demo</a>
        </div>
    </div>
</section>
<br>




<!-- ---- -->
<div class="container mt-4">
    <div class="section-title gradient-text mt-2 mb-2" >

        <h2 i18n>Frequently Asked Questions</h2>
    </div>
    <div class="row pt-4">
        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Which functionalities are available in your pharmacy software? </h4>
                <p i18n><strong>A:</strong> Clients frequently inquire about the features and functionalities of the Medeil Products software, such as inventory tracking, client administration, reporting tools, integration possibilities, and customer support services.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: Is it possible to modify your pharmacy software to meet our unique requirements? </h4>
                <p i18n><strong>A:</strong> Many pharmacies want to know if the software can be customized to meet their specific needs because they have different requirements and workflows. Customizing fields, reports, processes, and integrations may fall under this category.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: What is the procedure like and how long does it take to integrate your pharmacy software? </h4>
                <p i18n><strong>A:</strong>
                    Since pharmacies may find it difficult to adopt new software, they frequently inquire about the timetable, procedure, and support offered during this period. It's also typical to have questions concerning training, data migration, and continuing support. MEDEIL Standalone is the easiest downloadable software to install, while regarding our pharmacy SaaS apps, it's just a sign-up process to activate your subscription instantly for both the cloud version and mobile app version.</p>
            </div>
        </div>

        <div class="col-lg-6 col-md-12">
            <div class="faq-item">
                <h4 i18n>Q: What are the expenses related to the software for your pharmacy?</h4>
                <p i18n><strong>A:</strong>
                    Pharmacists prioritize cost while evaluating new software solutions. They could inquire about upfront costs, ongoing membership fees, additional costs for customizations or integrations, and any other unspecified costs. Vanuston offers straightforward and economical pharmacy software deployment, beginning with a free version.</p>
            </div>
        </div>
    </div>


</div>
<div class="row mb-3 mt-3" style="width: 100%;">
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Crowd Review</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.3/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Google</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.8/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Capterra</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.4/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Software Suggest</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.7/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>G2 Crowd</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.1/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Trust Radius</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.6/5.0</p>
        </div>
  </div>
</div>


<br>
<div class="container-md p-5 box-container">
  <h3 i18n style="color: white;">Call to Action</h3>
    <p i18n style="color:white">Ready to revolutionize your pharmacy operations?<a routerLink="/contact-us" routerLinkActive="active">Contact us </a> today for a personalized demo and discover how Medeil can empower your pharmacy to thrive in the modern healthcare landscape.</p>
  <a i18n (click)="appointment('mecial-pharmacy Demo')" class="cta-button">🚀 Request a Free Demo</a>
  </div>
<br>
<app-footer-style-two></app-footer-style-two>
